import { has, uniqBy } from 'lodash';

import type {
  ItemsPerScout,
  ItemsPerSubUnit,
  PurchaseOrderTableItem,
  SubRows,
  ToApproveItems,
} from '../types';

export const groupBySubUnitToApprove = (
  itemsPerSubUnit: ItemsPerSubUnit[],
  oldApprovableItems: PurchaseOrderTableItem & Pick<SubRows, 'userId'>[],
) =>
  itemsPerSubUnit
    .map(sub => ({
      isHeader: true,
      key: sub.key,
      subUnitId: sub.subUnitId || sub.key,
      subUnitName: sub.subUnitName || sub.key,
      subUnitNameRaw: sub.subUnitNameRaw || sub.key,
      children: oldApprovableItems
        .filter(item =>
          sub.subRows.some(
            (row: { userId: number }) => row.userId === item.userId,
          ),
        )
        .map(item => ({
          ...item,
        })),
    }))
    .filter(sub => sub.children.length > 0);

export const groupByScoutToApprove = (
  oldApprovableItems: PurchaseOrderTableItem[],
): ItemsPerScout[] =>
  uniqBy(oldApprovableItems, 'memberId').map(youth => ({
    isHeader: true,
    key: `${youth.memberId}`,
    scoutName: youth.name ?? '',
    children: oldApprovableItems
      .filter(item => item.memberId === youth.memberId)
      .map(item => ({
        ...item,
      })),
  }));

export const isHeaderOfSubUnit = (
  items: ToApproveItems,
): items is ItemsPerSubUnit => has(items, 'subUnitName');

export const filterItems = (
  items: PurchaseOrderTableItem[],
  searchQuery: string,
) =>
  items.filter(item =>
    [
      item.name,
      item.advancementName,
      item.memberId,
      item.bsaMemberId,
      item.personFullName,
    ]
      .filter(Boolean)
      .join(' ')
      .toLocaleLowerCase()
      .includes(searchQuery.toLowerCase()),
  );
